<template >
  <button v-if="!$page.props.is_production"
    class="whitespace-nowrap w-full pl-0 text-xs mx-0 button-color text-white font-bold w-full mb-0 py-2 text-center"
    @click="addToCart">
    &nbsp;<i class="fa fa-plus-circle plus-font-size" aria-hidden="true"></i>
    &nbsp;ADD FOOD ORDER
  </button>
</template>

<script>
export default {
  // data (){
  //     return {
  //         remove_food_order: false,
  //     }
  // },
  props: ['searchForm', 'day', 'cal_days'],
  methods: {

    loadAlreadyAddedCartData() {
      this.$emit('loadAlreadyAddedCartData');
    },

    async addToCart() {

      try {
        const response = await axios.post('add-food-order-to-cart', {
          // Request payload or data
          site: this.searchForm.site,
          offering_id: this.searchForm.offering_id,
          group_id: this.searchForm.group_id,
          order_date: this.day,
          day_id: this.cal_days.id
        });
        if (response.data.message == 'success') {
          this.loadAlreadyAddedCartData();
        }
        // console.log('add to cart successfull');
        // console.log(response);
        //    console.log(response.data.message);
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>


